
import { MY_PRODUCT, PCF } from './constant';
export type Language = 'en' | 'de';
export type Section = 'PCF' | 'My Product' | string;

export function formatNumber(value: number | string, language: Language, section: Section): string {
  const isDetailedSection = section === PCF || section === MY_PRODUCT;

  // Parse number safely depending on locale
  const parseLocalizedNumber = (val: string | number): number => {
    if (val === null || val === undefined) return 0;
    if (typeof val === 'number') return val;

    const hasComma = val.includes(',');
    const hasDot = val.includes('.');

    // if both are present and comma is after dot, it's likely German (e.g., 1.234,56)
    const isGermanFormat = hasComma && (!hasDot || val.lastIndexOf(',') > val.lastIndexOf('.'));

    const normalized = isGermanFormat ? val.replace(/\./g, '').replace(',', '.') : val.replace(/,/g, '');

    const parsed = parseFloat(normalized);
    return isNaN(parsed) ? 0 : parsed;
  };

  const parsedValue = parseLocalizedNumber(value);
  // Decide decimal digits based on precision
  const decimalPart = parsedValue.toString().split('.')[1] || '';
  const hasMoreThanTwoDecimals = decimalPart.length > 2;

  const fractionDigits = hasMoreThanTwoDecimals && isDetailedSection ? 4 : 2;

  const options: Intl.NumberFormatOptions = {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  };

  const locale = language === 'de' ? 'de-DE' : 'en-US';
  return new Intl.NumberFormat(locale, options).format(parsedValue);
}

export function parseLocaleNumber(value: string | number, language: 'en' | 'de', isZeroRequired?: boolean): number | null {
  if ((value === null || value === undefined) && isZeroRequired) return 0;
  if (typeof value === 'number') return value;

  const val = value?.trim();
  let parsedValue = '';

  if (language === 'de') {
    // German: "1.234,56" → "1234.56"
    parsedValue = val?.replace(/\./g, '').replace(',', '.');
  } else {
    // English: "1,234.56" → "1234.56"
    parsedValue = val?.replace(/,/g, '');
  }

  const num = parseFloat(parsedValue);
  return isNaN(num) ? null : num;
}
